import React from 'react';
import { CheckCircle2, ShieldCheck, Heart, Brain, Zap } from 'lucide-react';
import { Button } from '../ui/Button';
export function BenefitsSection() {
  const benefits = [{
    icon: <ShieldCheck className="w-6 h-6 text-[#2C7A7B]" data-id="element-1" />,
    title: "Silencia al 'Censor Interno'",
    desc: 'Aprende a detener esa voz que te juzga cada minuto del día.'
  }, {
    icon: <Zap className="w-6 h-6 text-[#2C7A7B]" data-id="element-2" />,
    title: 'Utilidad de Mantenimiento',
    desc: 'Descubre cómo generar valor real incluso en tus días más oscuros.'
  }, {
    icon: <Heart className="w-6 h-6 text-[#2C7A7B]" data-id="element-3" />,
    title: 'Framework de Valor Intrínseco',
    desc: 'Separa radicalmente tu autoestima de tu cuenta bancaria o tu lista de tareas.'
  }, {
    icon: <Brain className="w-6 h-6 text-[#2C7A7B]" data-id="element-4" />,
    title: 'El Retorno Progresivo',
    desc: 'Cómo volver a la acción desde la paz, no desde la desesperación.'
  }];
  return <section className="py-20 bg-white" data-id="element-5">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-6">
        <div className="text-center mb-16" data-id="element-7">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-8">
            Lo que este Libro Digital hará por ti
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-9">
            Este no es otro manual de "5 pasos para ser una supermujer". Es una
            intervención de emergencia para tu alma.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-10">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 p-6 rounded-xl bg-[#FDFBF7] border border-[#E2E8F0] hover:border-[#2C7A7B] transition-colors" data-id="element-11">
              <div className="flex-shrink-0 mt-1" data-id="element-12">{benefit.icon}</div>
              <div data-id="element-13">
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-14">
                  {benefit.title}
                </h3>
                <p className="text-slate-600" data-id="element-15">{benefit.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="bg-[#E6FFFA] rounded-2xl p-8 md:p-12 text-center max-w-4xl mx-auto" data-id="element-16">
          <h3 className="text-2xl font-bold text-[#234E52] mb-4" data-id="element-17">
            Recupera tu paz mental hoy mismo
          </h3>
          <ul className="text-left max-w-md mx-auto space-y-3 mb-8" data-id="element-18">
            <li className="flex items-center gap-3 text-[#285E61]" data-id="element-19">
              <CheckCircle2 className="w-5 h-5 flex-shrink-0" data-id="element-20" />
              <span data-id="element-21">Acceso inmediato y de por vida</span>
            </li>
            <li className="flex items-center gap-3 text-[#285E61]" data-id="element-22">
              <CheckCircle2 className="w-5 h-5 flex-shrink-0" data-id="element-23" />
              <span data-id="element-24">Ejercicios prácticos de 5 minutos</span>
            </li>
            <li className="flex items-center gap-3 text-[#285E61]" data-id="element-25">
              <CheckCircle2 className="w-5 h-5 flex-shrink-0" data-id="element-26" />
              <span data-id="element-27">Formato PDF compatible con todos los dispositivos</span>
            </li>
          </ul>
          <Button size="lg" withIcon onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-28">
            QUIERO RECUPERAR MI PAZ
          </Button>
        </div>
      </div>
    </section>;
}